window.SortControl = window.SortControl || {
  getSortStateKey: function (gridId) {
    gridId =
      gridId ||
      document
        .querySelector("[data-sort-control]")
        ?.getAttribute("data-grid-id") ||
      "default";
    return `product_grid_sort_${gridId}`;
  },

  saveSortState: function (sortValue, gridId) {
    try {
      siteStorage.set(this.getSortStateKey(gridId), sortValue);
    } catch (e) {
      console.warn("Could not save sort state to localStorage:", e);
    }
  },

  loadSortState: function (gridId) {
    try {
      return siteStorage.get(this.getSortStateKey(gridId));
    } catch (e) {
      console.warn("Could not load sort state from localStorage:", e);
      return null;
    }
  },

  getUserSortPrefKey: function (gridId) {
    gridId =
      gridId ||
      document
        .querySelector("[data-sort-control]")
        ?.getAttribute("data-grid-id") ||
      "default";
    return `product_grid_sort_user_pref_${gridId}`;
  },

  saveUserSortPreference: function (sortValue, gridId) {
    try {
      siteStorage.set(this.getUserSortPrefKey(gridId), sortValue);
    } catch (e) {
      console.warn("Could not save user sort preference to localStorage:", e);
    }
  },

  loadUserSortPreference: function (gridId) {
    try {
      return siteStorage.get(this.getUserSortPrefKey(gridId));
    } catch (e) {
      console.warn("Could not load user sort preference from localStorage:", e);
      return null;
    }
  },

  saveSortPreferences: function (sortValue, gridId) {
    this.saveSortState(sortValue, gridId);
    this.saveUserSortPreference(sortValue, gridId);
  },

  isSortValueValid: function (sortValue, sortOptions) {
    if (!sortValue || !sortOptions) return false;
    return sortOptions.some((opt) => opt.filter_sort_option === sortValue);
  },

  getEffectiveSortValue: function (
    urlSort,
    savedSort,
    userPref,
    defaultSort,
    sortOptions,
  ) {
    if (userPref && this.isSortValueValid(userPref, sortOptions)) {
      return { value: userPref, source: "userPreference" };
    }
    if (urlSort && this.isSortValueValid(urlSort, sortOptions)) {
      return { value: urlSort, source: "url" };
    }
    if (savedSort && this.isSortValueValid(savedSort, sortOptions)) {
      return { value: savedSort, source: "localStorage" };
    }
    return { value: defaultSort, source: "default" };
  },

  initializeSortControl: function (gridId, defaultSort, sortOptions) {
    const urlSort = UrlParamHandler.getUrlParam(window.location.href, "sort");
    const savedSort = this.loadSortState(gridId);
    const userPref = this.loadUserSortPreference(gridId);
    this.getEffectiveSortValue(urlSort, savedSort, userPref, defaultSort, sortOptions);
  },

  setDropdownValue: function (value, gridId) {
    try {
      const sortControl = document.querySelector(
        `[data-sort-control][data-grid-id="${gridId}"]`,
      );
      if (!sortControl) return;
      const selectElement = sortControl.querySelector('select[name="sort"]');
      if (!selectElement) return;
      selectElement.value = value;
      selectElement.dispatchEvent(new Event("change", { bubbles: true }));
    } catch (e) {
      console.error("[SortControl] Error setting dropdown value:", e);
    }
  },
};
